export default __webpack_public_path__ + "static/media/bg_2.1bff51e6.jpg";